import useSettings from "features/settings/useSettings";
import { size } from "lodash";
import moment, { Moment } from "moment";
import { useEffect, useRef, useState } from "react";
import { BookingDocumentItem, getScriptListData } from "./bookingDocumentApi";

export default function useScriptList() {
  const _storageStartDate = sessionStorage.getItem("scriptStartDate");
  const _storageEndDate = sessionStorage.getItem("scriptEndDate");
  const [range, setRange] = useState<
    { start?: Moment; end?: Moment } | undefined
  >({
    start: _storageStartDate
      ? moment(_storageStartDate).startOf("day")
      : moment().startOf("day"),
    end: _storageEndDate
      ? moment(_storageEndDate).endOf("day")
      : moment().endOf("day"),
  });

  const [settings, setSettings] = useSettings({ key: "scripts" });
  const loaded = useRef(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [documents, setDocuments] = useState<BookingDocumentItem[]>([]);

  async function handleFilter(
    startDate: string | undefined,
    endDate: string | undefined,
    boatIds: number[] | null,
    programIds: number[] | null,
    silent?: boolean,
  ) {
    if (!silent) {
      setLoading(true);
    }
    if (startDate) {
      sessionStorage.setItem("scriptStartDate", startDate);
    } else {
      sessionStorage.removeItem("scriptStartDate");
    }
    if (endDate) {
      sessionStorage.setItem("scriptEndDate", endDate);
    } else {
      sessionStorage.removeItem("scriptEndDate");
    }

    const { success, data } = await getScriptListData(
      startDate,
      endDate,
      boatIds,
      programIds,
    );
    console.log({ data });
    loaded.current = true;
    if (success) {
      setDocuments(data?.data || []);
    }
    if (!silent) {
      setLoading(false);
    }
  }

  function load(silent?: boolean) {
    return handleFilter(
      range?.start?.format("YYYY-MM-DD"),
      range?.end?.format("YYYY-MM-DD"),
      settings.boatIds,
      settings.programIds,
      silent,
    );
  }

  const isEmpty = loaded.current && size(documents) === 0;

  useEffect(() => {
    load();
  }, [range, settings.boatIds, settings.programIds]);

  return {
    documents,
    loading,
    load,
    handleFilter,
    setRange,
    range,
    loaded,
    isEmpty,
    settings,
    setSettings,
  };
}
